@let record =
  recordsEc.plugins.currentEntityPlugin.feature.selectors
    .getEditedEntity()
    .asSignal();
@let entityParent = entityParentSg();
@let recordParentId = recordParentIdSg();
@let recordValues = recordValuesSg();
@let attributes = displayAttributesSg();
@let recordTarget = recordTargetSg();
@let title = titleSg();
@let isSubmitting =
  recordsEc.plugins.editingPlugin.feature.selectors.isSubmitting.asSignal();

@if (record) {
  <atn-ds-centered-overlay>
    <atn-ds-widget
      [title]="title"
      class="edit-record-dialog"
    >
      <div class="edit-record-dialog__widget-content">
        @for (attr of attributes; track $index) {
          <atn-display-value
            [readonly]="attr.readonly"
            [type]="attr.type"
            [value]="recordValues[attr.id]"
            [label]="attr.name"
            [documentKey]="attr.documentKey"
            [recordTarget]="recordTarget"
            (valueChange)="attributeValueChangeHandler(attr.id, $event)"
          />
        }
        @if (entityParent) {
          <atn-entity-record-select
            [entity]="entityParent"
            [value]="recordParentId"
            (valueChange)="recordParentIdChangeHandler($event)"
          />
        }
      </div>
      <div
        footer
        class="edit-record-dialog__footer"
      >
        <atn-ds-button
          class="edit-record-dialog__footer-cancel-btn"
          type="transparent"
          (click)="cancelBtnClickHandler()"
          >Cancel</atn-ds-button
        >
        <atn-ds-button
          (click)="saveClickHandler()"
          [loading]="isSubmitting"
          >Save</atn-ds-button
        >
      </div>
    </atn-ds-widget>
  </atn-ds-centered-overlay>
}
